import React from 'react';

import { useIntl } from 'src/hooks/intl';

import { messages } from '../metric-cards/i18n';
import { TooltipWrapper } from '../metric-cards/styles';

import { generateTimeRange } from './utils';

export type Tooltip = {
  label: string;
  value: string | number;
};

type ChartTooltipProps = {
  startAt: string;
  tooltips: Tooltip[];
  dataAvailable: boolean;
};

/* eslint @typescript-eslint/ban-types: "warn" */
export const ChartTooltip: React.FC<ChartTooltipProps> = ({
  startAt,
  tooltips,
  dataAvailable,
}) => {
  const { formatMessage } = useIntl();

  const TimeRange = () => (
    <p>
      <strong>{`${formatMessage(messages.timeRange)}: `}</strong>
      {generateTimeRange(startAt)}
    </p>
  );

  if (!dataAvailable) {
    return (
      <TooltipWrapper>
        <p>{formatMessage(messages.noDataMessageText)}</p>
        <TimeRange />
      </TooltipWrapper>
    );
  }

  return (
    <TooltipWrapper>
      {tooltips.map(({ label, value }, index) => {
        const isAdditionalTooltipData = index !== 0;

        if (isAdditionalTooltipData && !value) return null;

        return (
          <p key={label}>
            <strong>{`${label}: `}</strong>
            {value}
          </p>
        );
      })}
      <TimeRange />
    </TooltipWrapper>
  );
};
